import { ICustomer, ICustomerData } from "@/entities";
import { ListCustomer } from "@/entities/listCustomer";
import { IAddress } from "@/entities/user/address";
import { ICustomerRepository } from "@/repositories";
import { ICustomerService } from "./customers.types";

export class CustomerService implements ICustomerService {
    constructor(private repository: ICustomerRepository) { }
    // async getSaleById(id: string): Promise<ISale | undefined> {
    //     return (await this.repository.get(id));
    // }

    async createCustomer(customerData: ICustomerData, saleID: string): Promise<ICustomer> {
        console.log("createCustomer input:", customerData, saleID);
        return (await this.repository.create(customerData, saleID));
    }

    async updateCustomer(customerData: ICustomerData): Promise<ICustomer> {
        console.log("updateCustomer input:", customerData);
        return (await this.repository.update(customerData));
    }

    async updateCustomerAddress(customerAddress: IAddress): Promise<IAddress> {
        console.log("updateCustomerAddress input:", customerAddress)
        return await this.repository.updateAddress(customerAddress);
    }

    async addExistingCustomer(customerID: string, saleID: string): Promise<void> {
        console.log("addExistingCustomer input:", customerID, saleID);
        return (await this.repository.createSaleCustomer(customerID, saleID));
    }

    async searchByPhone(keyword: string, nextToken?: string): Promise<ListCustomer> {
        return await this.repository.searchByPhone(keyword, nextToken);
    }

    async searchByName(keyword: string, nextToken?: string): Promise<ListCustomer> {
        return this.repository.searchByName(keyword, nextToken);
    }

    async searchByEmail(keyword: string, nextToken?: string): Promise<ListCustomer> {
        return this.repository.searchByEmail(keyword, nextToken);
    }

    // async syncSale(userData: ISaleData): Promise<ISale> {
    //     const user = await this.getSaleById(userData.id as string);
    //     if(user){
    //         return user;
    //     }
    //     return await this.createSale(userData);
    // }
}
